import { FaArrowUp, FaBookOpen, FaClock, FaHandsHelping, FaMoneyBill, FaPrayingHands } from 'react-icons/fa';
import { images } from '../constants'; 


const careerIntro = {
    sub: "Join Our Mission",
    heading: "Serve with Us at Siraj Islamic Center",
    description: "At Siraj Islamic Center, we welcome dedicated individuals to be part of our mission. Whether your passion lies in teaching, community outreach, administration, or youth programs, we provide fulfilling career opportunities that make a meaningful impact. Join us in serving our community and upholding Islamic values.",
    points: [
        "Faith-Based Environment",
        "Competitive Salary",
        "Opportunities for Growth",
        "Professional Development",
        "Supportive Team",
        "Serve the Community",
    ],
};


const benefits = [
    {
        id: 1,
        title: "Spiritual Fulfillment",
        description: "Work in an environment that nurtures faith, values, and community service.",
        icon: <FaPrayingHands />
    },
    {
        id: 2,
        title: "Islamic Learning",
        description: "Gain knowledge and training in Islamic teachings, community outreach, and leadership.",
        icon: <FaBookOpen />
    },
    {
        id: 3,
        title: "Fair Compensation",
        description: "Receive a competitive salary with additional benefits for dedicated service.",
        icon: <FaMoneyBill />
    },
    {
        id: 4,
        title: "Flexible Scheduling",
        description: "Enjoy work schedules that accommodate prayers, religious events, and personal needs.",
        icon: <FaClock />
    },
    {
        id: 5,
        title: "Supportive Community",
        description: "Be part of a team that values brotherhood, compassion, and mutual respect.",
        icon: <FaHandsHelping />
    },
    {
        id: 6,
        title: "Growth Opportunities",
        description: "Develop your skills and leadership potential within a respected Islamic institution.",
        icon: <FaArrowUp />
    }
];



const positions = [
    {
        id: 1,
        image: images.position1,
        title: 'Head Imam',
        content: 'Lead prayers, provide religious guidance, and oversee Islamic education programs for the community.',
        details: {
            location: 'On-site',
            timing: 'Full Time',
            hours: 'Standard Working Hours with Additional Religious Events',
            experience: 'Extensive Islamic Knowledge and Leadership Experience Required',
            position: 'One Position Available',
            days: 'Monday to Sunday (With Weekly Day Off)',
            salary: '$60K - $80K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Serve as the spiritual leader of the Islamic Center, guiding the community through leading daily prayers, delivering Friday sermons (Khutbahs), providing religious counseling, and ensuring the preservation and teaching of Islamic values. The Head Imam will also oversee educational programs and represent the center in community affairs.'
        ],
        responsibilities: [
            'Lead the five daily prayers, Jumu’ah prayers, and Eid prayers.',
            'Deliver weekly Khutbahs and provide religious lectures or classes.',
            'Offer spiritual guidance and counseling to community members.',
            'Oversee Islamic educational programs, including Quran classes and youth programs.',
            'Participate in community outreach and interfaith activities.',
            'Ensure religious events are conducted in accordance with Islamic principles.'
        ],
        qualifications: [
            'Strong foundation in Islamic scholarship with recognized credentials.',
            'Fluent in Arabic with proficiency in English for community engagement.',
            'Experience in leading prayers, delivering Khutbahs, and teaching.',
            'Excellent communication, leadership, and interpersonal skills.',
            'Ability to address diverse community needs with wisdom and compassion.',
        ],
    },
    {
        id: 2,
        image: images.position2,
        title: 'Islamic Teacher',
        content: 'Teach Quran, Hadith, Islamic Studies, and moral values to students of various age groups in the community.',
        details: {
            location: 'On-site',
            timing: 'Full Time',
            hours: 'Standard School Hours with Occasional Evening Classes',
            experience: 'Teaching Experience and Islamic Knowledge Required',
            position: 'Multiple Positions Available',
            days: 'Monday to Friday',
            salary: '$35K - $50K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'Join our educational team to provide high-quality Islamic education to students. The Islamic Teacher will prepare lessons, teach Quran recitation and memorization, explain Islamic principles, and nurture students’ moral and spiritual growth in accordance with the teachings of Islam.'
        ],
        responsibilities: [
            'Teach Quran with proper Tajweed, Tafseer, and memorization techniques.',
            'Deliver lessons on Hadith, Islamic Fiqh, Seerah, and moral values.',
            'Prepare lesson plans and educational materials tailored to student needs.',
            'Encourage students to practice Islamic etiquette and values.',
            'Assess student progress and provide constructive feedback.',
            'Collaborate with parents and other teachers for holistic development.'
        ],
        qualifications: [
            'Recognized Islamic education credentials or Ijazah in Quran.',
            'Proficiency in Arabic and strong command of English.',
            'Experience in teaching children and youth in an Islamic setting.',
            'Excellent communication and motivational skills.',
            'Ability to manage classroom effectively with patience and empathy.',
        ],
    },
    {
        id: 3,
        image: images.position3,
        title: 'Outreach Coordinator',
        content: 'Coordinate community outreach programs, organize events, and build strong relationships with local organizations and individuals.',
        details: {
            location: 'On-site',
            timing: 'Full Time',
            hours: 'Standard Working Hours with Some Evening/Weekend Events',
            experience: 'Community Engagement Experience Preferred',
            position: '1 Position Available',
            days: 'Monday to Friday (with occasional weekends)',
            salary: '$40K - $55K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'The Outreach Coordinator will be responsible for planning and executing programs that engage the community, strengthen partnerships, and promote the organization’s mission. This role involves managing events, developing outreach strategies, and ensuring active participation from diverse community members.'
        ],
        responsibilities: [
            'Plan and coordinate community events, workshops, and awareness campaigns.',
            'Build and maintain partnerships with local organizations, leaders, and volunteers.',
            'Promote programs and services through social media, newsletters, and public announcements.',
            'Manage outreach materials and ensure effective communication with the community.',
            'Recruit and train volunteers for events and community activities.',
            'Gather feedback from participants to improve future outreach efforts.'
        ],
        qualifications: [
            'Experience in community outreach, event planning, or public relations.',
            'Strong interpersonal and communication skills.',
            'Ability to work flexible hours, including evenings and weekends when needed.',
            'Proficiency in using social media and outreach tools.',
            'Organized, proactive, and capable of working independently and as part of a team.',
        ],
    },
    {
        id: 4,
        image: images.position4,
        title: 'Office Administrator',
        content: 'Oversee day-to-day office operations, manage administrative tasks, and ensure smooth coordination across departments.',
        details: {
            location: 'On-site',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Administrative or Office Management Experience Preferred',
            position: '1 Position Available',
            days: 'Monday to Friday',
            salary: '$35K - $45K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'The Office Administrator will manage and oversee office functions, maintain records, coordinate schedules, and support staff in their daily tasks. This role ensures efficient operations and provides administrative assistance to various departments to achieve organizational goals.'
        ],
        responsibilities: [
            'Manage office operations and ensure smooth workflow.',
            'Maintain accurate records, files, and documentation.',
            'Coordinate schedules, meetings, and appointments.',
            'Oversee supply inventory and place orders when necessary.',
            'Handle correspondence, phone calls, and email communication.',
            'Assist with HR and finance-related administrative tasks.',
        ],
        qualifications: [
            'Experience in administrative or office management roles.',
            'Excellent organizational and time-management skills.',
            'Strong verbal and written communication abilities.',
            'Proficiency in office software (MS Office Suite, Google Workspace).',
            'Ability to work independently and handle multiple tasks simultaneously.',
        ],
    },
    {
        id: 5,
        image: images.position5,
        title: 'Youth Coordinator',
        content: 'Plan, organize, and lead youth programs and activities to promote Islamic values, community engagement, and personal growth.',
        details: {
            location: 'On-site',
            timing: 'Full Time',
            hours: 'Standard Working Hours',
            experience: 'Youth Program or Community Engagement Experience Preferred',
            position: '1 Position Available',
            days: 'Monday to Friday (Some Evenings & Weekends Required)',
            salary: '$38K - $50K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'The Youth Coordinator will develop and implement programs aimed at engaging and empowering young members of the community. This role involves fostering an environment that promotes Islamic teachings, leadership skills, and positive social interactions among youth.'
        ],
        responsibilities: [
            'Plan and lead educational, recreational, and spiritual programs for youth.',
            'Organize events, workshops, and trips that promote Islamic values.',
            'Mentor and guide youth in personal, academic, and spiritual matters.',
            'Coordinate with parents and community members to support youth initiatives.',
            'Recruit, train, and supervise volunteers for youth programs.',
        ],
        qualifications: [
            'Experience in youth leadership, education, or community work.',
            'Strong understanding of Islamic principles and youth development needs.',
            'Excellent communication and interpersonal skills.',
            'Ability to inspire, mentor, and connect with young people.',
            'Organizational skills to plan and execute multiple activities effectively.',
        ],
    },
    {
        id: 6,
        image: images.position6,
        title: 'Event Coordinator',
        content: 'Plan, organize, and oversee community events, religious gatherings, and special programs to ensure smooth execution and community engagement.',
        details: {
            location: 'On-site',
            timing: 'Full Time',
            hours: 'Standard Working Hours (Some Evenings & Weekends Required)',
            experience: 'Event Planning or Community Engagement Experience Preferred',
            position: '1 Position Available',
            days: 'Monday to Friday (Plus Event Days)',
            salary: '$40K - $52K',
            deadline: 'Apply Now - Open Until Filled',
            number: '123-456-7890',
        },
        overviews: [
            'The Event Coordinator will manage all aspects of planning and executing community events, from religious celebrations to workshops and social gatherings. This role requires attention to detail, strong organizational skills, and the ability to work with diverse groups within the community.'
        ],
        responsibilities: [
            'Plan and organize religious, educational, and social events.',
            'Coordinate logistics including venue setup, catering, and guest management.',
            'Work closely with volunteers and staff to ensure event success.',
            'Promote events through community channels and social media.',
            'Manage event budgets and maintain expense records.',
        ],
        qualifications: [
            'Proven experience in event planning or coordination.',
            'Strong communication and teamwork skills.',
            'Ability to manage multiple projects simultaneously.',
            'Knowledge of Islamic events, traditions, and community needs.',
            'Organizational and problem-solving skills.',
        ],
    }

];

export { positions, benefits, careerIntro };